import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations/index.ts";

import { useSort } from "../context/hooks.ts";

import { ColumnHeader } from "./column-header";

export const ColumnHeaders = () => {
    const intl = useIntl();

    const titleSortProps = useSort("title");
    const categorySortProps = useSort("category");
    const statusSortProps = useSort("status");
    const timeFrameSortProps = useSort("timeFrame");

    return (
        <div css={headerRowCss}>
            <ColumnHeader
                {...titleSortProps}
                sortable={true}
                label={intl.formatMessage({
                    id: "roadmapFeatures.update",
                    defaultMessage: "Update"
                })}
            />
            <ColumnHeader
                {...categorySortProps}
                sortable={true}
                label={intl.formatMessage({
                    id: "roadmapFeatures.category",
                    defaultMessage: "Category"
                })}
            />
            <ColumnHeader
                {...statusSortProps}
                sortable={true}
                label={intl.formatMessage({
                    id: "roadmapFeatures.status",
                    defaultMessage: "Status"
                })}
            />
            <ColumnHeader
                {...timeFrameSortProps}
                sortable={true}
                label={intl.formatMessage({
                    id: "roadmapFeatures.time",
                    defaultMessage: "Time"
                })}
            />
            <ColumnHeader
                sortable={false}
                label={intl.formatMessage({
                    id: "roadmapFeatures.apps",
                    defaultMessage: "Apps"
                })}
            />
        </div>
    );
};

const headerRowCss = css({
    width: "100%",
    display: "grid",
    gridTemplateColumns:
        "minmax(34%, 4fr) minmax(100px, 1fr) minmax(75px, 1fr) 1fr minmax(188px, 1fr)",
    gridTemplateRows: "auto",
    gap: `0px ${token("space.300")}`,
    alignItems: "center",
    justifyContent: "start",
    padding: `${token("space.200")} ${token("space.300")} ${token(
        "space.150"
    )}`,
    borderBlockEnd: `1px solid ${wacToken("color.neutral.light400")}`,
    color: token("color.text.accent.gray"),
    fontSize: "12px",
    textAlign: "left",
    boxSizing: "border-box",
    [media.below.md]: {
        display: "none"
    }
});
